module.exports = __webpack_public_path__ + "img/logo.cb71dbe0.svg";